<template>
  <breeze-authenticated-layout>
    <template #header>
      <div class="flex">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          รายงาน CO.TH
        </h2>
      </div>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-6 py-4">
          <div class="grid grid-cols-1 gap-6">
            <div class="col-span-1">
              <breeze-label for="name" value="ข่วงวันที่ (ตั้งแต่-ถึง)*" class="mb-2" />
              <date-picker v-model="form.from" />
              <date-picker v-model="form.to" class="ml-2" />
              <breeze-input-error :message="form.errors.from" class="mt-2" />
              <breeze-input-error :message="form.errors.to" class="mt-2" />
            </div>
            <div class="col-span-1">
              <breeze-label for="name" value="เลือกรายงาน*" class="mb-2" />
              <select v-model="form.report_code" class="w-full sm:w-1/2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                <option :value="null">-- กรุณาเลือกรายงาน --</option>
                <option v-for="(report, index) in reports" :key="`r-${index}`" :value="report.code">{{ report.name }}</option>
              </select>
              <breeze-input-error :message="form.errors.to" class="mt-2" />
            </div>
          </div>
          <div class="mt-6">
            <breeze-button
              :class="{ 'opacity-25': form.processing }"
              :disabled="form.processing"
              @click="exportFile"
            >
              Export Excel
            </breeze-button>
          </div>
        </div>
      </div>
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeSecondaryButton from "@/Components/SecondaryButton";
import BreezeInputError from "@/Components/InputError";
import { DatePicker } from 'v-calendar';
import { format } from "date-fns";
import 'v-calendar/style.css';


export default {
  components: {
    BreezeAuthenticatedLayout,
    BreezeSecondaryButton,
    BreezeLabel,
    BreezeInputError,
    BreezeButton,
    DatePicker,
  },

  data() {
    return {
      form: this.$inertia.form({
        from: new Date(),
        to: new Date(),
        report_code: null,
      }),
      reports: [
        {'code': 1, 'name': 'รายชื่อเว็บไซต์/โดเมน .co.th ที่ผ่านการอนุมัติ ตามวันที่ที่อนุมัติ'},
        {'code': 2, 'name': 'รายชื่อเว็บไซต์/โดเมน .in.th ที่ผ่านการอนุมัติ ตามวันที่ที่อนุมัติ'},
        {'code': 3, 'name': 'รายชื่อเว็บไซต์/โดเมน ทั้งหมด ตามวันที่ที่สมัคร'},
      ],
    };
  },

  methods: {
    exportFile() {
      let from = format(new Date(this.form.from), "yyyy-MM-dd");
      let to = format(new Date(this.form.to), "yyyy-MM-dd");

      window.location.href = route("staff.registrations.reports.export_file") + `?from=${from}&to=${to}&report_code=${this.form.report_code}`;
    },
  },
};
</script>
